import type {IssueSecondaryNode} from '../../issue-viewer-secondary-query-types'

export const RELATES_TO_CONNECTION_PATH = ['topRelatesTo']

export type RelatesToConnection = IssueSecondaryNode['topRelatesTo']
export type RelatesToIssueNode = NonNullable<NonNullable<RelatesToConnection['nodes']>[number]>
